import { FC, useCallback, useEffect, useState } from "react";
import { nativeCallBackMethod } from "../../utils/NativeAppEvents";
import {
  useAppDispatch,
  useAppSelector,
} from "../../redux-store/CustomReduxHooks";
import { setNativeDeviceInfo } from "../../redux-store/reducers/CsAppSlice";
import { T_NavtiveDeviceInfo } from "../../globalTypes/GlobalTypes";
import {
  ABC_APP_APP_STORE_URL,
  ABC_APP_PLAY_STORE_URL,
  REGISTER_BIO_METRIC,
} from "../../utils/constants";
import {
  BIOMETRIC_DO_IT_LATER_STATUS,
  eraseCookie,
  getCookie,
  NATIVE_DEVICE_INFO,
  setCookie,
} from "../../utils/CSCookieHandler";
import CsLocalStorageUtils from "../../utils/CsLocalStorageUtils";
import { useLazyFetchAppVersionQuery } from "../Feature_GeneralAppElements/GeneralAppElements_Api";
import CustomPopup from "../../components/CustomPopup/CustomPopup";
import { defaultEmptyFun, getModuleNameFromPath } from "../../utils/helper";
import { Box, Typography, Stack, Button } from "@mui/material";
import { Colors } from "../../styles/constant";
import noConnectionImage from "../../assets/images/no-connection.svg";
import { useSaveUIException } from "../../hooks/useSaveUIException";

declare const window: any;

export const NativeBridge: FC = () => {
  const appDispatch = useAppDispatch();
  const [fetchAppVersion] = useLazyFetchAppVersionQuery();
  const { triggerSaveUIException } = useSaveUIException();
  const [alertAppUpdate, setAlertAppUpdate] = useState<boolean>(false);
  const [updateType, setUpdateType] = useState<string>("F");
  const csAppSlice = useAppSelector((state) => state.CsAppSlice);
  // const checkIfFirstInstall = useCallback(() => {
  //   const queryParams = new URLSearchParams(window.location.search);
  //   const firstInstall = queryParams.get("first_install");
  //   const deviceInfo: T_NavtiveDeviceInfo = JSON.parse(
  //     `${
  //       queryParams.get("device_info") || getCookie(NATIVE_DEVICE_INFO) || "{}"
  //     }`
  //   ) as T_NavtiveDeviceInfo;
  //   deviceInfo.isFirstInstall = firstInstall === "true" ? true : false;
  //   if (firstInstall === "true") {
  //     eraseCookie(BIOMETRIC_DO_IT_LATER_STATUS);
  //     eraseCookie(REGISTER_BIO_METRIC);
  //     CsLocalStorageUtils.clear("MOBILE");
  //     console.log("This is the first install of the app.");
  //   }
  //   console.log(deviceInfo as T_NavtiveDeviceInfo);
  //   appDispatch(setNativeDeviceInfo(deviceInfo as T_NavtiveDeviceInfo));
  //   setCookie(NATIVE_DEVICE_INFO, JSON.stringify(deviceInfo), 30);
  // }, []);

  const deviceInfoEvent = useCallback(() => {
    return nativeCallBackMethod({ type: "deviceInfo", isEnable: true })
      .then((response: any) => {
        console.log("Response from native code:", response);
        const deviceInfo = response as T_NavtiveDeviceInfo;
        setCookie(NATIVE_DEVICE_INFO, JSON.stringify(deviceInfo), 30);
        appDispatch(setNativeDeviceInfo(deviceInfo));
      })
      .catch((error) => {
        const currentPath = window?.location?.pathname;
        triggerSaveUIException({
          moduleName: getModuleNameFromPath(currentPath),
          pageName: currentPath || "",
          statusCode: 500,
          uiDisplayMessage: `fileName(NativeBridgeComp.tsx) and functionName(nativeCallBackMethod) `,
          errorMessage: {
            stk: error.stack || "No stack available",
            msg: error.message || "Unknown error occurred",
          },
        });
      });
  }, []);

  useEffect(() => {
    // let data =
    //   '{"deviceName":"Google sdk_gphone64_arm64","systemVersion":"13","deviceModel":"sdk_gphone64_arm64","identifier":"3d22de23b74c2111","systemName":"Android","isFirstInstall":true,"appVersion":"2.2.1"}';
    // console.log("Message from Android: ", data);
    // const deviceInfo = JSON.parse(data) as T_NavtiveDeviceInfo;
    // setCookie(NATIVE_DEVICE_INFO, JSON.stringify(deviceInfo), 30);
    // console.log("Device Info", deviceInfo);
    // appDispatch(setNativeDeviceInfo(deviceInfo));
    // if (deviceInfo.isFirstInstall) {
    //   console.log("I am here");
    //   eraseCookie(REGISTER_BIO_METRIC);
    //   CsLocalStorageUtils.clear("MOBILE");
    //   console.log("This is the first install of the app.");
    // }

    const messageHandler = (event: CustomEvent) => {
      console.log("Message from React Native Android: ", event.detail);

      // Handle the incoming message
      const deviceInfo = JSON.parse(event.detail) as T_NavtiveDeviceInfo;
      console.log("Device Info", JSON.stringify(deviceInfo));
      setCookie(NATIVE_DEVICE_INFO, JSON.stringify(deviceInfo), 30);
      appDispatch(setNativeDeviceInfo(deviceInfo));
      if (deviceInfo.isFirstInstall) {
        eraseCookie(BIOMETRIC_DO_IT_LATER_STATUS);
        eraseCookie(REGISTER_BIO_METRIC);
        CsLocalStorageUtils.clear("MOBILE");
        console.log("This is the first install of the app.");
      }
    };
    window.addEventListener("android_info", messageHandler);
    return () => {
      window.removeEventListener("android_info", messageHandler);
    };
  }, []);

  const sendMessageToTWA = () => {
    const message = {
      action: "LAUNCH_ANDROID_APP",
      payload: "Event from web app",
    };
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(message));
      console.log(
        "Sending event to TWA React Native Android " + JSON.stringify(message)
      );
    }
  };

  useEffect(() => {
    sendMessageToTWA();
    // if (
    //   window.location.search.includes("device_info") ||
    //   getCookie(NATIVE_DEVICE_INFO)
    // ) {
    //   checkIfFirstInstall();
    // }
    deviceInfoEvent();
  }, []);

  useEffect(() => {
    if (csAppSlice.NativeDeviceInfo?.systemName) {
      fetchAppVersion({
        appOSName: csAppSlice.NativeDeviceInfo.systemName,
        appVersion: csAppSlice.NativeDeviceInfo.appVersion,
      }).then((res) => {
        if (res.isSuccess && res.data) {
          if (res.data.payload.updateFlag === "N") {
            setAlertAppUpdate(false);
          } else {
            setAlertAppUpdate(true);
            setUpdateType(res.data.payload.updateFlag);
          }
        }
      });
    }
  }, [csAppSlice.NativeDeviceInfo]);

  const updateApp = () => {
    if (csAppSlice.NativeDeviceInfo?.systemName === "iOS") {
      window.location.href = ABC_APP_APP_STORE_URL;
    } else {
      updateAndroidApp();
    }
  };

  const updateAndroidApp = () => {
    const message = {
      action: "UPDATE_ANDROID_APP",
      playStoreURL: ABC_APP_PLAY_STORE_URL,
    };
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(message));
      console.log(
        "Sending event to TWA React Native Android " + JSON.stringify(message)
      );
    }
  };

  const renderPopUp = () => {
    return (
      <CustomPopup handleOpen={defaultEmptyFun} open={alertAppUpdate}>
        <Box padding="1.5rem 1rem">
          {/* <Box display="flex" justifyContent="center">
            <img src={noConnectionImage} alt="no-connection" />
          </Box> */}
          <Box marginTop="1.5rem">
            <Typography textAlign="center" variant="h3">
              Update App
            </Typography>
            <Typography
              marginTop="1rem"
              textAlign="center"
              variant="h5"
              paddingX="1.25rem"
              color={Colors.textGray}
            >
              {updateType === "O"
                ? "Do you want to update application into the latest version ?"
                : "Update to the latest version to use the application"}
            </Typography>
          </Box>
          <Stack direction={"row"}>
            {updateType === "O" && (
              <Button
                fullWidth
                variant="outlined"
                sx={{ margin: " 1rem .25rem .25rem  .25rem" }}
                onClick={() => setAlertAppUpdate(false)}
              >
                cancel
              </Button>
            )}
            <Button
              fullWidth
              variant="contained"
              sx={{ margin: " 1rem .25rem .25rem  .25rem" }}
              onClick={() => updateApp()}
            >
              Update
            </Button>
          </Stack>
        </Box>
      </CustomPopup>
    );
  };
  return alertAppUpdate ? renderPopUp() : <></>;
};
